import { Box, Grid, Text, Flex, Spinner, Alert, AlertIcon } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const ViewCertificate = ({ certificateId }) => {
  const [certificate, setCertificate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCertificate = async () => {
      try {
        const response = await fetch(`${BASE_URL}/admin/certificates/view_tc.php?certificate_id=${certificateId}`);
        const data = await response.json();

        if (data.success) {
          setCertificate(data.data[0]); // Assuming the data is an array with one object
        } else {
          throw new Error(data.message || 'Certificate not found');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCertificate();
  }, [certificateId]);

  if (loading) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100vh">
        <Spinner size="xl" />
      </Flex>
    );
  }

  if (error) {
    return (
      <Alert status="error" mt={4}>
        <AlertIcon />
        {error}
      </Alert>
    );
  }

  return (
    <Box
      width="210mm"
      height="297mm"
      padding="20mm"
      border="1px solid black"
      // fontFamily="Arial"
      fontSize="14px"
    >
      <Text fontSize="2xl" textAlign="center" fontWeight="bold" mb={4}>
        TRANSFER CERTIFICATE
      </Text>

      <Grid templateColumns="1fr auto" gap={4}>
        <Flex>
          <Text>T.C. No</Text>
          <Text ml="auto">:</Text>
        </Flex>
        <Text>{certificate.tc_no}</Text>

        <Flex>
          <Text>Admission No</Text>
          <Text ml="auto">:</Text>
        </Flex>
        <Text>{certificate.admission_no}</Text>

        <Flex>
          <Text>1. Name of the pupil</Text>
          <Text ml="auto">:</Text>
        </Flex>
        <Text>{certificate.student_name}</Text>

        <Flex>
          <Text>2. Father's/Guardian's Name</Text>
          <Text ml="auto">:</Text>
        </Flex>
        <Text>{certificate.father_guardian_name}</Text>

        <Flex>
          <Text>3. Nationality</Text>
          <Text ml="auto">:</Text>
        </Flex>
        <Text>{certificate.nationality}</Text>

        <Flex>
          <Text>4. Religion & Caste</Text>
          <Text ml="auto">:</Text>
        </Flex>
        <Text>{certificate.religion_caste}</Text>

        <Flex>
          <Text>5. Whether the candidate belongs to SC/ST</Text>
          <Text ml="auto">:</Text>
        </Flex>
        <Text>{certificate.sc_st_status}</Text>

        <Flex>
          <Text>6. Date of first admission with class</Text>
          <Text ml="auto">:</Text>
        </Flex>
        <Text>{certificate.first_admission_date}, {certificate.first_admission_class}</Text>

        <Flex>
          <Text>7. Date of Birth (in Christian era)</Text>
          <Text ml="auto">:</Text>
        </Flex>
        <Text>{certificate.date_of_birth}</Text>

        <Flex>
          <Text>8. Class in which the pupil last studied</Text>
          <Text ml="auto">:</Text>
        </Flex>
        <Text>{certificate.last_class_studied}</Text>

        <Flex>
          <Text>9. Whether qualified for promotion to higher class</Text>
          <Text ml="auto">:</Text>
        </Flex>
        <Text>{certificate.qualified_for_promotion}</Text>

        <Flex>
          <Text>10. Whether the pupil has paid all fees</Text>
          <Text ml="auto">:</Text>
        </Flex>
        <Text>{certificate.fees_paid}</Text>

        <Flex>
          <Text>11. Any fee concession availed</Text>
          <Text ml="auto">:</Text>
        </Flex>
        <Text>{certificate.fee_concession}</Text>

        <Flex>
          <Text>12. Total no. of working days in the academic year</Text>
          <Text ml="auto">:</Text>
        </Flex>
        <Text>{certificate.total_working_days}</Text>

        <Flex>
          <Text>13. Total no. of working days present by the pupil</Text>
          <Text ml="auto">:</Text>
        </Flex>
        <Text>{certificate.working_days_present}</Text>

        <Flex>
          <Text>14. Whether NCC Cadet/Boy Scout/Girl Guide</Text>
          <Text ml="auto">:</Text>
        </Flex>
        <Text>{certificate.ncc_scout_guide}</Text>

        <Flex>
          <Text>15. General conduct of the pupil</Text>
          <Text ml="auto">:</Text>
        </Flex>
        <Text>{certificate.general_conduct}</Text>

        <Flex>
          <Text>16. Date of application for Transfer Certificate</Text>
          <Text ml="auto">:</Text>
        </Flex>
        <Text>{certificate.application_date}</Text>

        <Flex>
          <Text>17. Date of issue of Transfer Certificate</Text>
          <Text ml="auto">:</Text>
        </Flex>
        <Text>{certificate.issue_date}</Text>

        <Flex>
          <Text>18. Reason for leaving the school</Text>
          <Text ml="auto">:</Text>
        </Flex>
        <Text>{certificate.reason_for_leaving}</Text>
      </Grid>

      {/* Footer Section */}
      <Grid templateColumns="repeat(3, 1fr)" mt={10} gap={4} textAlign="center">
        <Text>Prepared By</Text>
        <Text>Checked By</Text>
        <Text>Principal</Text>
      </Grid>

      <Grid templateColumns="repeat(3, 1fr)" gap={4} textAlign="center" mt={2}>
        <Text>Signature</Text>
        <Text>Signature</Text>
        <Text>Signature</Text>
      </Grid>
    </Box>
  );
};

export default ViewCertificate;
